import { RootState } from 'app/store/rootReducer';

export const selectPriceBeforeRecalculation = (state: RootState) =>
  state.priceBeforeRecalculation;
